import * as R from 'ramda';
import { UserRoleObject } from '../user-role-object';
import { removeRedundantAccessScopes } from './removeRedundantAccessScopes';

export const getAccessScopesByUserRoleName = (userRoleName: string, userRoles: UserRoleObject[]): string[] => {
  if (!userRoleName || !userRoles || !userRoles.length) {
    return [];
  }

  const foundUserRole = R.find((userRole: UserRoleObject) => userRole.role === userRoleName, userRoles);

  if (!foundUserRole) {
    return [];
  }

  return removeRedundantAccessScopes(foundUserRole.accessScopes);
};
